import theme from '../variables';
import { getColorFromVar } from '../variables/colors';

const alternativeTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    primary: 'yellow',
  },

  // Required to update the method with this theme's colors
  getColor: (key: string, level: number | undefined = undefined) =>
    getColorFromVar(alternativeTheme, key, level),
};

export default alternativeTheme;
